module.exports = __webpack_public_path__ + "img/icon-familyold.d6807386.png";